import * as React from "react";
import styled, { css } from "styled-components";

const StyledBox = styled.div<IStyleProps>`
  ${({ m }) =>
    m &&
    css`
      margin: ${({ theme }) => theme.space[`${m}`]};
    `};
  ${({ mt }) =>
    mt &&
    css`
      margin-top: ${({ theme }) => theme.space[`${mt}`]};
    `};
  ${({ mr }) =>
    mr &&
    css`
      margin-right: ${({ theme }) => theme.space[`${mr}`]};
    `};
  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${({ theme }) => theme.space[`${mb}`]};
    `};
  ${({ ml }) =>
    ml &&
    css`
      margin-left: ${({ theme }) => theme.space[`${ml}`]};
    `};
  ${({ mx }) =>
    mx &&
    css`
      margin-left: ${({ theme }) => theme.space[`${mx}`]};
      margin-right: ${({ theme }) => theme.space[`${mx}`]};
    `};
  ${({ my }) =>
    my &&
    css`
      margin-top: ${({ theme }) => theme.space[`${my}`]};
      margin-bottom: ${({ theme }) => theme.space[`${my}`]};
    `};
  ${({ p }) =>
    p &&
    css`
      padding: ${({ theme }) => theme.space[`${p}`]};
    `};
  ${({ pt }) =>
    pt &&
    css`
      padding-top: ${({ theme }) => theme.space[`${pt}`]};
    `};
  ${({ pr }) =>
    pr &&
    css`
      padding-right: ${({ theme }) => theme.space[`${pr}`]};
    `};
  ${({ pb }) =>
    pb &&
    css`
      padding-bottom: ${({ theme }) => theme.space[`${pb}`]};
    `};
  ${({ pl }) =>
    pl &&
    css`
      padding-left: ${({ theme }) => theme.space[`${pl}`]};
    `};
  ${({ px }) =>
    px &&
    css`
      padding-left: ${({ theme }) => theme.space[`${px}`]};
      padding-right: ${({ theme }) => theme.space[`${px}`]};
    `};
  ${({ py }) =>
    py &&
    css`
      padding-top: ${({ theme }) => theme.space[`${py}`]};
      padding-bottom: ${({ theme }) => theme.space[`${py}`]};
    `};
`;

interface IStyleProps {
  m?: number;
  mt?: number;
  mr?: number;
  mb?: number;
  ml?: number;
  mx?: number;
  my?: number;
  p?: number;
  pt?: number;
  pr?: number;
  pb?: number;
  pl?: number;
  px?: number;
  py?: number;
}

interface IProps extends IStyleProps {
  children: React.ReactNode;
}

const Box: React.FC<IProps> = ({
  children,
  m,
  mt,
  mr,
  mb,
  ml,
  mx,
  my,
  p,
  pt,
  pr,
  pb,
  pl,
  px,
  py,
}) => (
  <StyledBox
    m={m}
    mt={mt}
    mr={mr}
    mb={mb}
    ml={ml}
    mx={mx}
    my={my}
    p={p}
    pt={pt}
    pr={pr}
    pb={pb}
    pl={pl}
    px={px}
    py={py}
  >
    {children}
  </StyledBox>
);

export default Box;
